module.exports = __webpack_public_path__ + "img/jack-o-lantern.c2d87a05.svg";